import Smartphones from 'Todo/views/TodoTaxReportsView/containers/Smartphones'
import Tablets from 'Todo/views/TodoTaxReportsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TodoTaxReportsView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoTaxReportsView
